import { render, staticRenderFns } from "./ConfigLauncher.vue?vue&type=template&id=2be0b1e4&scoped=true&"
import script from "./ConfigLauncher.vue?vue&type=script&lang=js&"
export * from "./ConfigLauncher.vue?vue&type=script&lang=js&"
import style0 from "./ConfigLauncher.vue?vue&type=style&index=0&id=2be0b1e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be0b1e4",
  null
  
)

export default component.exports